import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import InterimManagement from "@/pages/InterimManagement";

export const Route = createFileRoute("/by/interim-management")({
  head: () => routeHead('Interim Management — AGAPE Беларусь', META_DESCRIPTIONS.interim.by, '/by/interim-management'),
  component: InterimManagement,
});
